import CreateAdminModal from "./create-admin-modal.component";

export default CreateAdminModal;
